import Vue from 'vue';
import App from './app';

new Vue({ // eslint-disable-line
  el: '#app',
  render: h => h(App)
});
